'use client'
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useRef, useState, useLayoutEffect } from 'react';
import { Typography } from '../Typography/Typography.js';

const AppOriginTile = ({ appLogoUrl, appName, appOrigin, }) => {
    const ref = useRef(null);
    const [showAppName, setShowAppName] = useState(false);
    useLayoutEffect(() => {
        if (ref.current) {
            const { width, height } = ref.current.getBoundingClientRect();
            if (width < height * 2) {
                setShowAppName(true);
            }
            else {
                setShowAppName(false);
            }
        }
    }, [ref, setShowAppName]);
    return (jsxs("div", { className: 'app-origin-tile', children: [Boolean(appName) && (jsx("div", { className: 'app-origin-tile__title', children: appLogoUrl ? (jsxs(Fragment, { children: [jsx("img", { alt: 'app_logo', src: appLogoUrl, className: 'app-origin-tile__logo', ref: ref }), showAppName && (jsx(Typography, { color: 'primary', variant: 'body_normal', children: appName }))] })) : (jsx(Typography, { "data-testid": 'app-name', color: 'primary', variant: 'body_normal', children: appName })) })), appOrigin && (jsx(Typography, { color: 'secondary', variant: 'body_normal', weight: 'regular', children: appOrigin }))] }));
};

export { AppOriginTile };
